export default "__VITE_ASSET__XQSgu2sN__"